import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

const EditDetail = ({
    open,
    onClose,
    onSubmit,
    detail,
    name,
    min,
    max,
}) => {
    const [editedDetail, setEditedDetail] = useState({
        name: '',
        value: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (detail) {
            setEditedDetail({
                name: detail.name || '',
                value: detail.value || '',
            });
        }
    }, [detail]);

    const handleChange = field => (event) => {
        setEditedDetail(prev => ({
            ...prev,
            [field]: event.target.value,
        }));
        setErrors(prev => ({
            ...prev,
            [field]: '',
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!editedDetail.name) newErrors.name = 'Required';
        if (!editedDetail.value) newErrors.value = 'Required';
        
        const value = parseInt(editedDetail.value);
        if (isNaN(value)) newErrors.value = 'Must be a number';
        if (value < min) newErrors.value = `Minimum value is ${min}`;
        if (value > max) newErrors.value = `Maximum value is ${max}`;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validate()) {
            onSubmit(editedDetail);
        }
    };

    const handleClose = () => {
        setErrors({});
        onClose();
    };

    const actions = [
        <FlatButton
            label='Cancel'
            onClick={handleClose}
        />,
        <FlatButton
            label='Update'
            primary
            onClick={handleSubmit}
        />,
    ];

    return (
        <Dialog
            title={`Edit ${name}`}
            actions={actions}
            modal={false}
            open={open}
            onRequestClose={handleClose}
        >
            <div className='row'>
                <div className='col-xs-6'>
                    <TextField
                        floatingLabelText='Value'
                        value={editedDetail.value}
                        onChange={handleChange('value')}
                        errorText={errors.value}
                        fullWidth
                    />
                </div>
                <div className='col-xs-6'>
                    <TextField
                        floatingLabelText='Name'
                        value={editedDetail.name}
                        onChange={handleChange('name')}
                        errorText={errors.name}
                        fullWidth
                    />
                </div>
            </div>
        </Dialog>
    );
};

EditDetail.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    detail: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
};

export default EditDetail;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/Misc/EditDetail.jsx